<template>
    <!-- 融资明细列表 -->
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束时间"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" @keyup.enter.native="getList(true)" placeholder="捆包号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.order_sn" @keyup.enter.native="getList(true)" placeholder="融资单号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.redeem_status" collapse-tags placeholder="赎货状态" filterable>
                    <el-option :value="1" :label="'未赎'"></el-option>
                    <el-option :value="2" :label="'已赎'"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.pieces" multiple collapse-tags placeholder="片数" @visible-change="getSelectWarehouseList('pieces')">
                    <el-option v-for="(list,index) in selectMapC.pieces" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.storage_location" placeholder="库位"></el-input>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.issuing_id" multiple collapse-tags placeholder="开证公司" @visible-change="getSelectWarehouseList('issuing_id')">
                    <el-option v-for="(list,index) in selectMapC.issuing_id" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.contract_no" placeholder="采购合同号"></el-input>
                <!-- <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.finance_order_sn" placeholder="融资提单号"></el-input> -->
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-if="isShowMore" v-model="params.remark	" placeholder="备注"></el-input>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="pay_date_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="计息开始时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="pay_date_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="计息结束时间"></el-date-picker>
                </div>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="expiry_date_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="到期日期开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="expiry_date_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="到期日期结束"></el-date-picker>
                </div>
               
               <!-- <el-select class="search_select search_inputBox" v-model="params.finance_type" multiple collapse-tags placeholder="融资类型" @visible-change="getSelectList">
                    <el-option :value="1" label="L/C"></el-option>
                    <el-option :value="2" label="T/T"></el-option>
                    <el-option :value="3" label="D/P"></el-option>
                </el-select> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="finance.pledge.details" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow"  @relativefile="relativeFile" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">件数:{{totalObj.finance_number}}件</div>
                <div class="totalNumber">方数:{{totalObj.finance_cube}}m³</div>
                <div class="totalNumber">融资货值:{{totalObj.finance_amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="finance.pledge.details" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
            <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>

        </div>
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    import relativeFile from '../../../components/downloadRelativeFile.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                startintime:"",
                pay_date_start:"",
                pay_date_end:"",
                expiry_date_start:"",
                expiry_date_end:"",
                params:{
                    start_time:"",
                    end_time:"",
                    order_sn:"",
                    issuing_id:"",
                    redeem_status:"",
                    page:1,
                    per_page:50
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                last_page:1,
                total:0,
                selectRow:[],
                warehouseList:[],
                warehouse_id:"",
                pieces:"",
                cube:"",
                return_pieces:"",
                return_cube:"",
                check_cube:"",
                sales_cube:"",
                inbound_time:new Date(),
                breedList:[],
                brandList:[],
                supplierList:[],
                selectMap:{
                    pledgeissuing:[],
                    pledgestatus:[]
                },
                list:[],
                tableCol:[
                    {colName:"融资时间",colKey:"finance_date",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资提单号",colKey:"order_sn",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"赎货状态",colKey:"redeem_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"index_thickness",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"index_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"方数",colKey:"original_cube",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资单价",colKey:"cube_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资费用平摊",colKey:"finance_cost",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资成本单价",colKey:"finance_cost_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购合同号",colKey:"contract_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货柜",colKey:"container_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"计息日期",colKey:"pay_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"到期日期",colKey:"expiry_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                isShowMore:false,
                downLoadFileDialog:false,
                downFilesList:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    status:[],
                    bale_status:[],
                    pieces:[],
                    status_text:[],
                    issuing_id:[]
                }
            }
        },
        created(){
            if(sessionStorage.FINANCE_DETAIL_ID){
                this.id=sessionStorage.FINANCE_DETAIL_ID;
                this.params.finance_id=sessionStorage.FINANCE_DETAIL_ID;
                sessionStorage.removeItem("FINANCE_DETAIL_ID")
            }
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getSelectWarehouseList(target){
                this.params.types= 'finance';
                this.$getSelectWarehouseList(target,this.params,"","finance").then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.pay_date_start = "";
                this.pay_date_end = "";
                this.expiry_date_start = "";
                this.expiry_date_end = "";
                this.startintime = "";
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.params.pay_date_start=this.formatTimeZero(this.pay_date_start);
                this.params.pay_date_end=this.formatTimeZero(this.pay_date_end);
                this.params.expiry_date_start=this.formatTimeZero(this.expiry_date_start);
                this.params.expiry_date_end=this.formatTimeZero(this.expiry_date_end);

                // this.params.startintime=this.formatTimeZero(this.startintime);
                this.tableLoading = true;
                this.params.finance_id = this.id;
                this.$postColumnList("/erp/finance.pledge.details",this.params,res=>{
                    this.pl(res.data.data.data.last_page)
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        item.purchase_id="查看对账单";
                        if(item.finance_date!=0){
                            this.list[index].finance_date = this.formatTime(item.finance_date*1000)
                        }else{
                            this.list[index].finance_date = "";
                        }
                        if(item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTime(item.inbound_time*1000)
                        }else{
                            this.list[index].inbound_time = "";
                        }
                        if(item.pay_date!=0){
                            this.list[index].pay_date = this.formatTime(item.pay_date*1000)
                        }else{
                            this.list[index].pay_date = "";
                        }
                        if(item.expiry_date!=0){
                            this.list[index].expiry_date = this.formatTime(item.expiry_date*1000)
                        }else{
                            this.list[index].expiry_date = "";
                        }
                        // this.list[index].original_width_total = parseInt(this.list[index].original_width_total)
                        this.list[index].cube = this.keepLimit(this.list[index].cube)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            rowClick(obj){
                
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
            excelExport(){
                this.params.finance_id = this.id;
                this.$exportExecl("/erp/finance.pledge.details.export","融资明细",this.params)
            },
        },
        components:{
            tabletem,
            pagination,
            relativeFile
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
